/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Hide_Event_Aria_LabelInputs */

const en_timing_sync_hide_event_aria_label = /** @type {(inputs: Timing_Sync_Hide_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide current event`)
};

const fr_timing_sync_hide_event_aria_label = /** @type {(inputs: Timing_Sync_Hide_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masquer l'evenement actuel`)
};

const de_timing_sync_hide_event_aria_label = /** @type {(inputs: Timing_Sync_Hide_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuelles Ereignis ausblenden`)
};

const it_timing_sync_hide_event_aria_label = /** @type {(inputs: Timing_Sync_Hide_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nascondi evento corrente`)
};

const ru_timing_sync_hide_event_aria_label = /** @type {(inputs: Timing_Sync_Hide_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скрыть текущее событие`)
};

const es_timing_sync_hide_event_aria_label = /** @type {(inputs: Timing_Sync_Hide_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocultar evento actual`)
};

const zh_cn2_timing_sync_hide_event_aria_label = /** @type {(inputs: Timing_Sync_Hide_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隐藏当前事件`)
};

const ja_timing_sync_hide_event_aria_label = /** @type {(inputs: Timing_Sync_Hide_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在のイベントを非表示`)
};

const hi_timing_sync_hide_event_aria_label = /** @type {(inputs: Timing_Sync_Hide_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तमान घटना को छुपाएँ`)
};

const pt_pt2_timing_sync_hide_event_aria_label = /** @type {(inputs: Timing_Sync_Hide_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocultar evento atual`)
};

/**
* | output |
* | --- |
* | "Hide current event" |
*
* @param {Timing_Sync_Hide_Event_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_hide_event_aria_label = /** @type {((inputs?: Timing_Sync_Hide_Event_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Hide_Event_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timing_sync_hide_event_aria_label(inputs)
	if (locale === "de") return de_timing_sync_hide_event_aria_label(inputs)
	if (locale === "it") return it_timing_sync_hide_event_aria_label(inputs)
	if (locale === "ru") return ru_timing_sync_hide_event_aria_label(inputs)
	if (locale === "es") return es_timing_sync_hide_event_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_timing_sync_hide_event_aria_label(inputs)
	if (locale === "ja") return ja_timing_sync_hide_event_aria_label(inputs)
	if (locale === "hi") return hi_timing_sync_hide_event_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_timing_sync_hide_event_aria_label(inputs)
	return en_timing_sync_hide_event_aria_label(inputs)
});